import { LOCATION_CHANGE } from '../../../../../shared/frontend/libs/router/redux-store';
import { TAction } from '../actions/types/action';
import { TCharacterDetailsClientState } from '../libs/store';

export type TVideoPlayerState = {
  visible: boolean;
  closed: boolean;
  showCloseButton: boolean;
  dockableSlots: TVideoPlayerDockLocations[];
};

const DEFAULT_STATE: TVideoPlayerState = {
  visible: false,
  closed: false,
  showCloseButton: false,
  dockableSlots: []
};

const SET_VIDEO_PLAYER_CLOSED = 'VIDEO_PLAYER/SET_VIDEO_PLAYER_CLOSED';
const SET_VIDEO_PLAYER_VISIBLE = 'VIDEO_PLAYER/SET_VIDEO_PLAYER_VISIBLE';
const SET_VIDEO_PLAYER_CLOSE_BUTTON_VISIBLE = 'VIDEO_PLAYER/SET_VIDEO_PLAYER_CLOSE_BUTTON_VISIBLE';
const ADD_DOCKABLE_SLOT = 'VIDEO_PLAYER/ADD_DOCKABLE_SLOT';
const REMOVE_DOCKABLE_SLOT = 'VIDEO_PLAYER/REMOVE_DOCKABLE_SLOT';

export type TVideoPlayerDockLocations = 'stream' | 'floating';

export const actions = {
  setVisible(visible: boolean): TAction<boolean> {
    return { type: SET_VIDEO_PLAYER_VISIBLE, payload: visible };
  },
  setClosed(closed: boolean): TAction<boolean> {
    return { type: SET_VIDEO_PLAYER_CLOSED, payload: closed };
  },
  setCloseButtonVisible(show: boolean): TAction<boolean> {
    return { type: SET_VIDEO_PLAYER_CLOSE_BUTTON_VISIBLE, payload: show };
  },
  addDockableSlot(location: TVideoPlayerDockLocations) {
    return {
      type: ADD_DOCKABLE_SLOT,
      payload: location
    };
  },
  removeDockableSlot(location: TVideoPlayerDockLocations) {
    return {
      type: REMOVE_DOCKABLE_SLOT,
      payload: location
    };
  }
};

export function reducer(
  state: Partial<TCharacterDetailsClientState> = DEFAULT_STATE,
  action: TAction<any>
): Partial<TCharacterDetailsClientState> {
  switch (action.type) {
    case SET_VIDEO_PLAYER_CLOSED: {
      return {
        ...state,
        closed: action.payload,
        showCloseButton: false
      };
    }
    case SET_VIDEO_PLAYER_VISIBLE: {
      return {
        ...state,
        visible: action.payload
      };
    }
    case SET_VIDEO_PLAYER_CLOSE_BUTTON_VISIBLE: {
      return {
        ...state,
        showCloseButton: action.payload
      };
    }
    case ADD_DOCKABLE_SLOT: {
      const dockableSlots = [...state.dockableSlots, action.payload];
      return {
        ...state,
        dockableSlots
      };
    }
    case REMOVE_DOCKABLE_SLOT: {
      const dockableSlots = state.dockableSlots.filter((slot: string) => slot !== action.payload);
      return {
        ...state,
        dockableSlots
      };
    }
    case LOCATION_CHANGE: {
      return {
        ...state,
        dockableSlots: [],
        closed: false // allow video to re-open after a page change
      };
    }
    default: {
      return state;
    }
  }
}
